/**
 * cb腾讯地图路线规划回调函数
 * @param {*} ret 
 */
export function cb(ret) {
    var coords = ret.result.routes[0].polyline,
    pl = [];
    //坐标解压（返回的点串坐标，通过前向差分进行压缩）
    var kr = 1000000;
    for (var i = 2; i < coords.length; i++) {
    coords[i] = Number(coords[i - 2]) + Number(coords[i]) / kr;
    }
    //将解压后的坐标放入点串数组pl中
    for (var n = 0; n < coords.length; n += 2) {
    pl.push(new window.TMap.LatLng(coords[n], coords[n + 1]));
    }
    display_polyline(pl); //显示路线
    //标记起终点marker
}

/**
 * display_polyline创建路线
 * @param {*} pl 
 */
export function display_polyline(pl){
    // console.log(pl);
    // // let color = ['rgba(0, 180, 0, 1)','rgba(255, 0, 0, 1)','rgba(204,153, 0, 1)','rgba(255, 0, 0, 1)','rgba(204,153, 0, 1)','rgba(0, 180, 0, 1)']
    // let geo = []
    // pl.forEach(item=>{
    //     var obj = {
    //         path: [item.lat,item.lng]
    //     }
    //     geo.push(obj)
    // })
    // var newGeo = []
    // geo.forEach(list=>{
    //     var obj = {
    //         path: list,
    //         color: 'rgba(0, 180, 0, 1)'
    //     }
    //     newGeo.push(obj)
    // })
    // console.log(newGeo);
    //创建 MultiPolyline显示折线
    new window.TMap.MultiPolyline({
        id: 'polyline-layer', //图层唯一标识
        map: window.map,// 绘制到目标地图
        //折线样式定义
        styles: {
            'style_blue': new window.TMap.PolylineStyle({
                color: '#FE5300', //线填充色
                width: 3, //折线宽度
                borderWidth: 1, //边线宽度
                borderColor: '#FFF', //边线颜色
                lineCap: 'round', //线端头方式
                showArrow: false,  // 显示箭头
                arrowOptions:{
                    width: 6,
                    height: 10,
                    space: 20,
                }
            }),
            // 彩虹线
            'caihong':new window.TMap.PolylineStyle({
                color: '#FE5300', //线填充色
                width: 8, //折线宽度
                borderWidth: 1, //边线宽度
                showArrow: true,
                arrowOptions: {
                    width: 6,
                    height: 10,
                    space: 70
                },
                lineCap: 'round',
            }),
        },
        //折线数据定义
        geometries: [
            {
                id: 'pl_1', // 折线唯一标识，删除时使用
                styleId: 'style_blue',  // 绑定样式名
                // styleId: 'caihong', 
                paths: pl,
                // rainbowPaths: newGeo,  // 彩虹线数组
            }
        ]
    });
}
